import { jsx as _jsx } from "react/jsx-runtime";
import { useRouter } from "next/router";
import { useCarReviewsHubTracking } from "@cinch-nx/data-tracking";
import { HubCardSkeleton } from "@cinch-nx/landing-ui-shared";
import { NoReviews } from "../no-reviews/no-reviews";
import { ReviewCard } from "../review-card/review-card";
import styles from "./review-cards-list.module.css";
export var ReviewCardsList = function(param) {
    var reviews = param.reviews, page = param.page, _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? true : _isLoading, selectedMake = param.selectedMake, selectedModel = param.selectedModel;
    var isFallback = useRouter().isFallback;
    var trackOnReviewCardClick = useCarReviewsHubTracking().trackOnReviewCardClick;
    var filteredReviews = reviews === null || reviews === void 0 ? void 0 : reviews.filter(function(item) {
        return !!(item && item.path);
    });
    if (isFallback || isLoading) {
        return /*#__PURE__*/ _jsx("div", {
            "data-testid": "skeletonPlaceHolder",
            children: Array.from({
                length: 10
            }).map(function(_, idx) {
                return /*#__PURE__*/ _jsx(HubCardSkeleton, {
                    featured: idx === 0
                }, idx);
            })
        });
    }
    return (filteredReviews === null || filteredReviews === void 0 ? void 0 : filteredReviews.length) > 0 ? /*#__PURE__*/ _jsx("ul", {
        children: filteredReviews === null || filteredReviews === void 0 ? void 0 : filteredReviews.map(function(item, idx) {
            return /*#__PURE__*/ _jsx("li", {
                className: styles.listItem,
                children: /*#__PURE__*/ _jsx("a", {
                    href: item.path,
                    className: styles.link,
                    "aria-label": item.title,
                    onClick: function() {
                        return trackOnReviewCardClick("".concat(item.make, " ").concat(item.model));
                    },
                    children: /*#__PURE__*/ _jsx(ReviewCard, {
                        title: item.title,
                        image: item.heroImage,
                        starRating: item.starRating,
                        snippet: item.snippet,
                        featured: idx === 0 && page === 1
                    })
                })
            }, item.id);
        })
    }) : /*#__PURE__*/ _jsx(NoReviews, {
        selectedMake: selectedMake,
        selectedModel: selectedModel
    });
};
